// src/components/StyledComponents/StyledComponents.ts

import styled, { css, keyframes } from 'styled-components';
import { MEDIA_BREAKPOINTS } from '@/constants/layout';

const buttonTransitions = css`
  transition:
    width 0.3s ease,
    height 0.3s ease,
    font-size 0.3s ease,
    background-color 0.3s ease,
    transform 0.3s ease,
    color 0.3s ease,
    opacity 0.3s ease;
`;

const hoverAnimation = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
`;

export const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;

  background-color: ${({ theme }) => theme.primaryColor};
  border: 2px solid ${({ theme }) => theme.menuColor};
  color: ${({ theme }) => theme.textColor};
  cursor: pointer;
  ${buttonTransitions}

  &:hover {
    background-color: ${({ theme }) => theme.MenuItemSelectedColor};
    color: ${({ theme }) => theme.backgroundColor};
    animation: ${hoverAnimation} 0.5s ease forwards;
  }
`;

export const MenuButton = styled(Button)<{ $isSelected?: boolean }>`
  cursor: pointer;
  user-select: none;

  font-family: ${({ theme }) => theme.fonts.rubikBoldItalic};

  width: ${({ theme }) => theme.sizes.small.menuButtonWidth};
  height: ${({ theme }) => theme.sizes.small.menuButtonHeight};

  background-color: ${({ theme, $isSelected }) =>
    $isSelected ? theme.MenuItemSelectedColor : theme.menuColor};

  color: ${({ theme, $isSelected }) =>
    $isSelected ? theme.backgroundColor : theme.textColor};

  padding: 10px;
  font-size: 14px;
  border: none;
  border-radius: 8px;
  ${buttonTransitions}

  &:hover {
    background-color: ${({ theme }) => theme.hoverColor};
    color: ${({ theme }) => theme.backgroundColor};
    transform: translateY(-2px);
  }

  /* ---------------- Desktop styles ---------------- */

  @media (min-width: ${MEDIA_BREAKPOINTS.mediumScreen}) {
    position: relative;
    border-radius: 0;
    transform: none;

    width: auto;
    min-width: fit-content;

    height: 36px;

    padding: 0 12px;
    padding-inline-start: 8px;

    border: none;
    border-inline-start: 1px solid ${({ theme }) => theme.MenuItemSelectedColor};

    &:first-child {
      border-inline-start: none;
      padding-inline-start: 0;
    }

    background: transparent;

    color: ${({ theme, $isSelected }) =>
      $isSelected ? theme.MenuItemSelectedColor : theme.textColor};

    &:hover {
      color: ${({ theme }) => theme.MenuItemSelectedColor};
      background: rgba(255, 255, 255, 0.06);
    }

    /* underline */
    &::after {
      content: '';
      position: absolute;
      left: 50%;
      bottom: -4px;
      width: 80%;
      height: 2px;
      background: ${({ theme }) => theme.MenuItemSelectedColor};
      transform: translateX(-50%) scaleX(${({ $isSelected }) => ($isSelected ? 1 : 0)});
      transform-origin: center;
      transition: transform 0.3s ease;
    }

    &:hover::after {
      transform: translateX(-50%) scaleX(1);
    }

    font-size: 18px;

    @media (max-width: 1280px) {
      font-size: 15px;
      padding: 0 10px;
      padding-inline-start: 7px;
    }
  }
`;

const StyledButtons = { Button, MenuButton, hoverAnimation };
export default StyledButtons;